module.exports = __webpack_public_path__ + "static/media/loginpinwheel.a6ebfeeb.svg";